import { ThemeSelectors } from "@at/design-system-foundation";
import styled from "styled-components";

export const VideoWrapper = styled.div`
  width: 100%;
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  background-color: #000;
  @media (min-width: 900px) {
    position: absolute;
    inset: 50% 0 auto 0;
    transform: translateY(-50%);
  }
  img {
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    @media (max-width: 700px) {
      height: auto;
    }
  }

  .video {
    margin: calc(${({ theme }) => ThemeSelectors.getGridUnit(theme)} * 2) auto;
    clear: left;
    display: flex;
    flex: 0 0 auto;
    flex-flow: column nowrap;
    align-items: center;

    iframe {
      width: 100%;
    }

    @media (min-width: 768px) {
      display: block;
      float: right;
      clear: none;

      iframe {
        width: auto;
      }
    }
  }
`;

export const Iframe = styled.iframe`
  position: absolute;
  height: 100%;
  left: 0;
  top: 0;
  width: 100%;
  vertical-align: middle;
`;

export const PlayButton = styled.button`
  box-sizing: border-box;
  margin: auto;
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 80px;
  height: 80px;
  padding-top: 14px;
  padding-left: 8px;
  line-height: 20px;
  border: 2px solid #fff;
  border-radius: 50%;
  color: #f5f5f5;
  text-align: center;
  text-decoration: none;
  background-color: rgba(102, 102, 102, 0.6);
  font-size: 20px;
  font-weight: bold;
  font-variation-settings: "wght" 700;
  transition: all 0.3s ease;

  :hover {
    background-color: rgba(102, 102, 102, 0.6);
    box-shadow: 0px 0px 10px rgba(255, 255, 100, 0.8);
    text-shadow: 0px 0px 10px rgba(255, 255, 100, 1);
  }

  ::after {
    content: "";
    display: inline-block;
    position: relative;
    top: -5px;
    left: 3px;
    border-style: solid;
    border-width: 10px 0 10px 20px;
    border-color: transparent transparent transparent white;
  }
`;
